module.exports = __webpack_public_path__ + "img/online.aaba3478.svg";